// 合同照片
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let contractPic = get(state, 'currentContractorDetail.contractInfo.contractPic', {})
  // let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('合同照片'),
    content: [
      {
        title: i18n.gettext('合同照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: contractPic
      }
    ]
  }
}
